import { RefObject, useEffect } from 'react'

/**
 * Calls `onClickAway` for pointer presses that land outside the element `ref`
 * points at, while `active`.
 *
 * Listens on `pointerdown` in the capture phase, so a click that dismisses the
 * element fires before React sees it and can't act on a row that is about to
 * unmount.
 */
export const useClickAway = (
    ref: RefObject<HTMLElement | null>,
    active: boolean,
    onClickAway: () => void,
) => {
    useEffect(() => {
        if (!active) return
        const onPointerDown = (event: PointerEvent) => {
            const node = ref.current
            if (node && !node.contains(event.target as Node)) onClickAway()
        }
        document.addEventListener('pointerdown', onPointerDown, true)
        return () =>
            document.removeEventListener('pointerdown', onPointerDown, true)
    }, [active, onClickAway, ref])
}
